import { render, staticRenderFns } from "./TempRenewPage.vue?vue&type=template&id=471bb51a&scoped=true"
import script from "./TempRenewPage.vue?vue&type=script&lang=js"
export * from "./TempRenewPage.vue?vue&type=script&lang=js"
import style0 from "./TempRenewPage.vue?vue&type=style&index=0&id=471bb51a&prod&scoped=true&lang=css"
import style1 from "./TempRenewPage.vue?vue&type=style&index=1&id=471bb51a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471bb51a",
  null
  
)

export default component.exports